/**
 * H3 — APK 강제 업데이트 화면.
 * Vite SPA 부팅 시 /api/version 조회 → versionCode < min_supported_version_code 인 경우 노출.
 * 사용자는 이 화면을 우회할 수 없음 (router 진입 자체를 막음).
 */
interface ForceUpdateProps {
  apkUrl: string;
  currentVersionCode: number;
  minSupportedVersionCode: number;
}

export function ForceUpdate({ apkUrl, currentVersionCode, minSupportedVersionCode }: ForceUpdateProps) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[var(--bg)] px-xl">
      <div className="max-w-md text-center space-y-lg">
        <div className="text-[64px] leading-none">⚡️</div>
        <h1 className="font-display text-[24px] font-medium text-[var(--text-primary)] leading-tight">
          Butler 업데이트가 필요해요
        </h1>
        <p className="text-[14px] text-[var(--text-secondary)] leading-relaxed">
          대표님, 사용 중인 앱 버전이 너무 오래되었어요.
          <br />
          최신 APK를 받아 설치해 주세요.
        </p>
        <div className="bg-[var(--surface)] border border-[var(--border)] rounded-lg p-md text-[12px] text-[var(--text-muted)] font-mono space-y-xs">
          <div>현재 버전: build {currentVersionCode}</div>
          <div>최소 필요: build {minSupportedVersionCode}</div>
        </div>
        <button
          type="button"
          onClick={() => window.open(apkUrl, '_blank')}
          className="w-full py-[14px] rounded-lg bg-[var(--accent)] text-[var(--accent-fg)] font-medium text-[15px] hover:opacity-90 transition-opacity"
        >
          APK 다운로드
        </button>
        <p className="text-[11px] text-[var(--text-muted)] leading-relaxed">
          다운로드 후 알림에서 APK 파일을 열어 설치할 수 있습니다.
          <br />
          설치 후 앱을 다시 실행해 주세요.
        </p>
      </div>
    </div>
  );
}

/** 권장 업데이트 토스트 (강제는 아님, 10초 후 자동 사라짐). */
interface UpdateRecommendedToastProps {
  apkUrl: string;
  onDismiss: () => void;
}

export function UpdateRecommendedToast({ apkUrl, onDismiss }: UpdateRecommendedToastProps) {
  return (
    <div className="fixed bottom-20 left-md right-md z-50 bg-[var(--surface)] border border-[var(--border)] rounded-xl shadow-butler-md p-md flex items-center gap-md">
      <div className="flex-1 min-w-0">
        <div className="text-[13px] text-[var(--text-primary)] font-medium">새 버전이 있습니다</div>
        <div className="text-[11px] text-[var(--text-muted)] mt-[2px]">잠시 후 업데이트를 권장드려요</div>
      </div>
      <button
        type="button"
        onClick={() => window.open(apkUrl, '_blank')}
        className="text-[12px] text-[var(--accent)] font-medium px-md py-[6px]"
      >
        업데이트
      </button>
      <button
        type="button"
        onClick={onDismiss}
        className="text-[12px] text-[var(--text-muted)] px-sm py-[6px]"
        aria-label="닫기"
      >
        ✕
      </button>
    </div>
  );
}
